import { Directive, HostListener, ElementRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormGroup } from '@angular/forms';

@Directive({
    selector: '[appFocusInvalidInput]',
    // host-proert:[],
    // tslint:disable-next-line: use-host-property-decorator
    host: {
        '(submit)': 'ngSubmit($event)',
        '(reset)': 'onReset()'
    },
})
export class FocusInvalidInputDirective {

    constructor(private el: ElementRef) { }
    @HostListener('submit', ['$event'])

    ngSubmit() {
        const invalidControl = this.el.nativeElement.querySelectorAll('.ng-invalid');

        if (invalidControl.length > 0) {
            invalidControl[0].scrollIntoView();
            invalidControl[0].focus();
        }
    }
}
